import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button } from "@mui/material";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import { loginRequest } from "../../services/authConfig";

export const SignInButton = (props) => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginPopup(loginRequest).catch((e) => {
      console.error(e);
    });
  };

  return (
    <Button
      onClick={handleLogin}
      variant="contained"
      color="primary"
      size="large"
      startIcon={<LoginOutlinedIcon />}
      sx={{
        px: 4,
        py: 1.25,
        fontSize: 16,
        fontWeight: 700,
        borderRadius: 1.5,
      }}
      {...props}
    >
      Sign in
    </Button>
  );
};
